import { createFileRoute } from "@tanstack/react-router";
import { Film } from "lucide-react";

import { AuditStatCards } from "@/components/brand-intel/creative-audit/audit-stat-cards";
import { FormatMixPerformance } from "@/components/brand-intel/creative-audit/format-mix-performance";
import { PlatformAdaptation } from "@/components/brand-intel/creative-audit/platform-adaptation";
import { TopPerformingCreatives } from "@/components/brand-intel/creative-audit/top-performing-creatives";
import { CreativeFatigueTracker } from "@/components/brand-intel/creative-audit/creative-fatigue-tracker";
import { AICreativeRecommendations } from "@/components/brand-intel/creative-audit/ai-creative-recommendations";
import { UnlockCreativeCard } from "@/components/brand-intel/creative-audit/unlock-modal";
import { mCreativeAuditData } from "@/mock/brand-intel";

export const Route = createFileRoute("/dashboard/intelligence/_layout/creative-audit")({
  component: CreativeAudit,
});

export function CreativeAudit() {
  return (
    <section className="w-full space-y-6">
      <div className="flex items-center gap-2">
        <Film className="size-5 text-muted-foreground" strokeWidth={2.5} />
        <h2 className="text-lg font-semibold text-foreground">Creative Audit</h2>
      </div>

      <AuditStatCards />

      <div className="grid gap-6 lg:grid-cols-2">
        <FormatMixPerformance />
        <PlatformAdaptation />
      </div>

      <div className="relative">
        <div className="space-y-6">
          <div className="grid gap-6 lg:grid-cols-2">
            <TopPerformingCreatives items={mCreativeAuditData.top_creatives} blurred />
            <CreativeFatigueTracker items={mCreativeAuditData.fatigue_tracker} blurred />
          </div>
          <AICreativeRecommendations items={mCreativeAuditData.ai_recommendations} blurred />
        </div>
        <div className="absolute inset-0 z-10 flex items-center justify-center">
          <UnlockCreativeCard />
        </div>
      </div>
    </section>
  );
}
